import { render, staticRenderFns } from "./comp_Home-ImagesSlider.vue?vue&type=template&id=6b8b065a&scoped=true&"
import script from "./comp_Home-ImagesSlider.vue?vue&type=script&lang=js&"
export * from "./comp_Home-ImagesSlider.vue?vue&type=script&lang=js&"
import style0 from "./comp_Home-ImagesSlider.vue?vue&type=style&index=0&id=6b8b065a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b065a",
  null
  
)

export default component.exports